// Copyright (c) 2023-present VexFlow contributors: https://github.com/vexflow/vexflow/graphs/contributors
// MIT License
import { CommonMetrics } from '../src/fonts/common_metrics';
import { CustomFont } from '../src/fonts/custom_glyphs';
export const Font = {
    data: CustomFont,
    metrics: CommonMetrics,
};
export default Font;
